import { postNewData } from './cmsService'
import { TASK } from 'fixtures/api'
import { TxtFailedSubmitData, TxtSuccessSubmitTask } from 'fixtures/texts'
import { timestamp } from 'helpers/timestampHelper'
import { getTaskListData } from 'Redux/actions/TaskActions'
import store from 'Redux/store'

export const submitTask = async (type, content, user) => {
  content.createdBy = user.username
  content.createdAt = timestamp(new Date())

  try {
    const send = await postNewData(TASK[type](), content)
    if (send.status === 200 || send.status === 201 || send.status === 204) {
      alert(TxtSuccessSubmitTask)
      store.dispatch(getTaskListData(type))
    } else {
      throw send
    }
  } catch (error) {
    alert(TxtFailedSubmitData)
    throw TxtFailedSubmitData
  }
}
